module.exports = __webpack_public_path__ + "static/media/439a2ded-d7a4-42d4-8660-ef8765fa7486.d6e0c9ca.woff";